import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-6 pt-4 flex justify-between" }
const _hoisted_2 = { class: "space-x-2 flex items-center" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center gap-2"
}

import { Button } from '@/components/marketplace/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormNavigation',
  props: {
    canProceed: { type: Boolean },
    isFirstStep: { type: Boolean },
    isLastStep: { type: Boolean },
    isLoading: { type: Boolean },
    submitLabel: {}
  },
  emits: ["prev", "next", "submit", "cancel"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "mt-auto" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Button), {
        variant: "outline",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev'))),
        disabled: _ctx.isFirstStep
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Back ")
        ])),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Button), {
          variant: "outline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Cancel ")
          ])),
          _: 1
        }),
        _createVNode(_unref(Button), {
          disabled: !_ctx.canProceed || _ctx.isLoading,
          class: "h-9 min-w-[120px] flex items-center justify-center",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isLastStep ? _ctx.$emit('submit') : _ctx.$emit('next')))
        }, {
          default: _withCtx(() => [
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.isLastStep ? (_ctx.submitLabel || 'Create Talent Pool') : 'Next'), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "animate-spin h-4 w-4 text-white",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0\n                 c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ], -1),
                  _createTextVNode(" Processing... ")
                ])))
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ], 64))
}
}

})